import {http} from "../http";

export interface GoogleAuth{

}

export interface EnableOrdDisableTypes {
    code : string;
    detail : string
}

export interface CheckSmsCodeRequest {
    userName : string
    verfication : number
}

export interface CheckSmsCodeResponse {
    code : string;
    detail : string
    messages : {
        MESSAGE : string
    }[]
}

export interface AuthCodeVerifyRequest {
    secret : string
    verfication : number
}

export const enableGoogleAuth = async (): Promise<EnableOrdDisableTypes> => {
    const { data } = await http.post<EnableOrdDisableTypes>(`auth/totp-register/enable`);
    return data;
};

export const disableGoogleAuth = async (): Promise<EnableOrdDisableTypes> => {
    const { data } = await http.post<EnableOrdDisableTypes>(`auth/totp-register/disable`);
    return data;
};

export const checkGoogleAuthSmsCode = async (requestData : CheckSmsCodeRequest): Promise<CheckSmsCodeResponse> => {
    const { data } = await http.post<CheckSmsCodeResponse>(`auth/totp-register/status`, requestData);
    return data;
};

export const googleAuthCodeVerify = async (requestData : AuthCodeVerifyRequest): Promise<EnableOrdDisableTypes> => {
    const { data } = await http.post<EnableOrdDisableTypes>(`auth/totp-register/verify`, requestData);
    return data;
};
